import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  disabled?: boolean;
}

export function BouncingDotsLoader({ className, disabled = false }: Props) {
  return (
    <div
      className={cn(
        "flex gap-1 items-center justify-center *:w-[6px] *:h-[6px] *:rounded-full *:animate-bounce-up-down h-7 w-7",
        disabled && "*:animate-none!",
        className,
      )}
    >
      <div
        className={`${disabled ? "bg-secondary-n-900" : "bg-primary-n-900"}`}
      ></div>
      <div
        className={`${
          disabled ? "bg-secondary-n-800" : "bg-primary-n-800"
        } delay-300!`}
      ></div>
      <div
        className={`${
          disabled ? "bg-secondary-n-700" : "bg-primary-n-700"
        } delay-500!`}
      ></div>
    </div>
  );
}
